import { Option } from "@me-team/common/src/interfaces/interfaces";
import { CUSTOM_CITY_OPTION_VALUE } from "@me-team/common/src/constants/city";

type CityValue = Option["value"] | null;

interface GetCitySelectValueParams {
    showCustomCityInput: boolean;
    cityOptions: Option[];
    cityValue?: CityValue;
    currentSelectedCityOption?: Option | null;
    selectedCityOption?: Option | null;
}

const isSameOptionValue = (optionValue?: CityValue, value?: CityValue): boolean => {
    if (optionValue === null || optionValue === undefined || value === null || value === undefined) {
        return false;
    }

    return String(optionValue) === String(value);
};

export const getCitySelectValue = ({
    showCustomCityInput,
    cityOptions,
    cityValue,
    currentSelectedCityOption,
    selectedCityOption,
}: GetCitySelectValueParams): Option | null => {
    if (showCustomCityInput) {
        return cityOptions.find((option) => Number(option.value) === CUSTOM_CITY_OPTION_VALUE) || null;
    }

    if (cityValue === null || cityValue === undefined) {
        return null;
    }

    const selectedCityFromOptions = cityOptions.find((option) => isSameOptionValue(option.value, cityValue));
    if (selectedCityFromOptions) {
        return selectedCityFromOptions;
    }

    if (currentSelectedCityOption && isSameOptionValue(currentSelectedCityOption.value, cityValue)) {
        return currentSelectedCityOption;
    }

    if (selectedCityOption && isSameOptionValue(selectedCityOption.value, cityValue)) {
        return selectedCityOption;
    }

    return null;
};
